import { Modal } from 'baseui/modal'
import { Search } from 'baseui/icon'
import { SIZE } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import usePdlSearchV2 from './usePdlSearchV2'
import PdlSearchForm from './PdlSearchForm'
import PdlSearchResults from './PdlSearchResults'
import { SearchModalHeader } from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/styled-components'
import useMeterSearchStyles from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/useMeterSearchStyles'

const PdlSearchModal = () => {
  const { t } = useTranslation()
  const { isPulse, headerIconSize } = useMeterSearchStyles()
  const { isOpen, currentViewPage, modalOverrides, resetPdlSearchData, updatePdlConfigData } = usePdlSearchV2()

  const handleClose = () => {
    updatePdlConfigData({ isOpen: false })
    resetPdlSearchData()
  }

  return (
    <Modal onClose={handleClose} isOpen={isOpen} size={SIZE.auto} overrides={modalOverrides}>
      <SearchModalHeader $pulse={isPulse}>
        <Search size={headerIconSize} />
        {t('subscriptionTools:pdl_search.module_title')}
      </SearchModalHeader>

      {currentViewPage === 'search' && <PdlSearchForm />}
      {currentViewPage === 'results' && <PdlSearchResults />}
    </Modal>
  )
}

export default PdlSearchModal
